<nz-spin [nzSpinning]="isLoading"></nz-spin>

@if (!isLoading && data) {
  <!-- WO -->
  <div>
    @if (getWorkOrderItem().url) {
      <a [href]="getWorkOrderItem().url" [title]="getWorkOrderItem().name" target="_blank" class="clickable text-success mt-3">
        <span [ngClass]="{'text-danger': getWorkOrderItem()?.status}">{{ getWorkOrderItem().name }}</span>
      </a>
    } @else {
      <span [ngClass]="{'text-danger': getWorkOrderItem()?.status}">{{ getWorkOrderItem().name }}</span>
    }
    - {{ getWorkOrderItem().title }}
  </div>

  <div class="hr-separator"><hr></div>

  <div class="row">
    <div class="col col-lg-12">
      <table class="table table-borderless">
        <tr>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Activ. Date: <strong>{{ data?.activation_date | niceDate : '-' : true }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Compl. Date: <strong>{{ data?.completion_date | niceDate : '-' : true }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Status: <strong>{{ data?.status | nullAsWhatever : '-' }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Type: <strong>{{ data?.type | nullAsWhatever : '-' }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Due Date: <strong>{{ data?.due_date | niceDate : '-' : true }}</strong></td>
        </tr>
      </table>
    </div>

    <div class="w-100">
      <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
        <!-- DESCRIPTION -->
        <li [ngbNavItem]="1">
          <a ngbNavLink class="text-dark font-weight-bold border-start-0 square-top-left-border">Description</a>
          <ng-template ngbNavContent>
            <div class="pt-3 px-3 pe-3 pb-0 mt-0 word-breaker">
              <span [innerHTML]="data?.description | normalizeNewLines | newLineBreaker | nullAsWhatever : '-'"></span>
            </div>
          </ng-template>
        </li>
        <!-- DESCRIPTION -->

        <!-- EQUIPMENT TAG -->
        <li [ngbNavItem]="2">
          <a ngbNavLink class="text-dark font-weight-bold">Equipment Tag</a>
          <ng-template ngbNavContent>
            <div [ngClass]="{'pt-3 pe-3 px-3 pb-0 mt-0': true, 'scrollable-container': true}">
              @if (data.equipment_tags.length > 0) {
                <table class="table table-borderless mb-0 transparent-head">
                  <thead>
                    <tr>
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">TagName</th>
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">Description</th>
                      @if (data?.activity_code_count > 0) {
                        <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">Activity</th>
                      }
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light text-center">Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (equipmentTag of data.equipment_tags; track equipmentTag.tag + '-' + $index) {
                      <tr>
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          <span class="clickable" (click)="onDataCardDrawerOpen(equipmentTag.tag)">
                            {{ equipmentTag.tag }}
                          </span>
                        </td>
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          {{ equipmentTag.description | nullAsWhatever : '-' }}
                        </td>
                        @if (data?.activity_code_count > 0) {
                          <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                            @if (equipmentTag.is_fe) {
                              {{ equipmentTag.activity_codes.join(', ') | nullAsWhatever : '-' }}
                            }
                          </td>
                        }
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0 text-center">
                          <app-is-checked
                            [show]="equipmentTag.is_fe"
                            [isChecked]="!!equipmentTag.completed_status"></app-is-checked>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </ng-template>
        </li>
        <!-- EQUIPMENT TAG -->
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-0"></div>
    </div>
  </div>
}
